import type { GameSettings } from "../types";

type Cue = "click" | "mail" | "judge" | "rewind" | "final";

let context: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (typeof window === "undefined" || !("AudioContext" in window)) return null;
  context ??= new AudioContext();
  if (context.state === "suspended") void context.resume();
  return context;
}

const cueMap: Record<Cue, { frequency: number; duration: number; type: OscillatorType }> = {
  click: { frequency: 520, duration: 0.035, type: "sine" },
  mail: { frequency: 740, duration: 0.12, type: "sine" },
  judge: { frequency: 420, duration: 0.08, type: "triangle" },
  rewind: { frequency: 155, duration: 0.4, type: "sawtooth" },
  final: { frequency: 260, duration: 0.65, type: "sine" }
};

export function playCue(cue: Cue, settings: GameSettings): void {
  const ctx = getContext();
  if (!ctx || settings.masterVolume <= 0 || settings.sfxVolume <= 0) return;
  const config = cueMap[cue];
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  const now = ctx.currentTime;
  oscillator.type = config.type;
  oscillator.frequency.setValueAtTime(config.frequency, now);
  if (cue === "rewind") oscillator.frequency.exponentialRampToValueAtTime(70, now + config.duration);
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(Math.max(0.0001, settings.masterVolume * settings.sfxVolume * 0.08), now + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + config.duration);
  oscillator.connect(gain).connect(ctx.destination);
  oscillator.start(now);
  oscillator.stop(now + config.duration + 0.02);
}
